import { render, staticRenderFns } from "./Penyaluran.vue?vue&type=template&id=10fcaf26"
import script from "./Penyaluran.vue?vue&type=script&lang=js"
export * from "./Penyaluran.vue?vue&type=script&lang=js"
import style0 from "./Penyaluran.vue?vue&type=style&index=0&id=10fcaf26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports